var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"justify":"center"}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"fluid":""}},[_c('v-card',{attrs:{"outlined":""}},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-card-title',[_c('p',{staticClass:"font-weight-black"},[_vm._v(" Menu Equipe Mult ")])])],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }